import React, { useState } from 'react';
import './Product.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { ButtonAdd } from '../Button/ButtonAdd';
import { ButtonRemove } from '../Button/ButtonRemove';
import QuotedVariantPrice from '../../sitePages/QuotedVariantPrice';
import { useTranslation } from 'react-i18next';
import Callout from '../../sitePages/Callout';
import ShowBenefitsModal from '../ShowBenefitsModal';

export type ProductProps = {
  id: string;
  title: string;
  isSelected: boolean;
  showMoreItems?: string[];
  synopsisText?: string;
  showQuotedPrice?: boolean;
  monthlyPrice?: number;
  annualPrice?: number;
  paymentMethod?: string;
  noOfInstallments?: number;
  isPurchased: boolean;
  isDisabled: boolean;
  addOrRemoveProduct: (id: string) => void;
  showCooloffWarning: boolean;
  cooloffWarningText?: string;
  culture: string;
  showKeyBenefits: boolean;
  hideRemovePlanLink?: boolean;
  showKeyBenefitsInProductCard?: boolean;
};

const Product = ({
  id,
  title,
  isSelected,
  showMoreItems,
  synopsisText,
  showQuotedPrice,
  monthlyPrice,
  annualPrice,
  paymentMethod,
  noOfInstallments,
  isPurchased,
  isDisabled,
  addOrRemoveProduct,
  showCooloffWarning,
  cooloffWarningText,
  culture,
  showKeyBenefits,
  hideRemovePlanLink,
  showKeyBenefitsInProductCard
}: ProductProps): JSX.Element => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const onShowMore = () => {
    setShowModal(true);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  const addOrRemovePlan = () => {
    addOrRemoveProduct(id);
  };

  const { t } = useTranslation();

  const renderShowMoreItems = () => {
    return showMoreItems?.map((item: string, i) => (
      <li key={`more-items-${i}`}>{item}</li>
    ));
  };

  const disableProduct = isPurchased || showCooloffWarning;
  console.log('showKeyBenefitsInProductCard', showKeyBenefitsInProductCard);
  return (
    <div
      style={{
        backgroundColor: disableProduct ? 'lightgray' : ''
      }}
      className={`osp-card${
        isSelected && !disableProduct ? ' selected' : ''
      } product-card cms-card`}>
      <div className='product-card-header'>
        <h4>
          {title}
          {isSelected && !showCooloffWarning && (
            <FontAwesomeIcon icon={faCheckCircle} className='tick' />
          )}
        </h4>
      </div>
      {showQuotedPrice && !isPurchased && (
        <QuotedVariantPrice
          noOfInstallments={noOfInstallments}
          totalPrice={annualPrice}
          monthlyPrice={monthlyPrice}
          paymentMethod={paymentMethod}
          culture={culture}
        />
      )}
      <div className='product-card-body'>
        {showCooloffWarning && (
          <div className='m2-top'>
            <Callout text={cooloffWarningText ?? ''} isWarning={true} />
          </div>
        )}
        {!showCooloffWarning && (
          <div className='product-card-button-container'>
            {isSelected && !isPurchased && !hideRemovePlanLink && (
              <ButtonRemove
                name='btn-remove-plan-${id}'
                onClick={addOrRemovePlan}
                text={t('customer-product-page.remove-from-plan')}
              />
            )}
            {!isSelected && !isPurchased && (
              <ButtonAdd
                name='btn-add-plan-${id}'
                onClick={addOrRemovePlan}
                disabled={isDisabled}
                text={t('customer-product-page.add-to-plan')}
              />
            )}
            {isPurchased && <p className='p2'>Purchased</p>}
          </div>
        )}
      </div>
      {showKeyBenefits && (
        <div className='product-footer'>
          <p className='cms'>{synopsisText}</p>
        </div>
      )}
      {showKeyBenefitsInProductCard && (
        <div className='product-footer'>
          <br></br>
          <p className='cms'>{renderShowMoreItems()}</p>
        </div>
      )}
      {showKeyBenefits &&
        (showKeyBenefitsInProductCard === false ||
          showKeyBenefitsInProductCard === undefined) && (
          <div>
            <ButtonRemove
              name='btn-show-more'
              text={t('customer-product-page.show-more')}
              additionalClassNames='small'
              onClick={onShowMore}
            />
            <ShowBenefitsModal
              showModal={showModal}
              title={title}
              showMoreItems={showMoreItems}
              onCloseModal={onCloseModal}
            />
          </div>
        )}
    </div>
  );
};

export default Product;
